import { Component, Input, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable, filter, map } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { User } from '../../../core/models/user.model';
import { AuthState, Logout } from '../../../core/states/auth.state';

import { SidenavService } from '../../../shared/services/sidenav.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbItem, HeaderService } from '../../services/header.service';

@UntilDestroy()
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [CommonModule, MatMenuModule, NgbCollapseModule, ReactiveFormsModule, RouterModule],
})
export class HeaderComponent implements OnInit {
    public projectName = ' ';

    public breadcrumbs: BreadcrumbItem[] = [];

    public isCollapsed: boolean = true;

    public loggedUser$!: Observable<User | null>;
    public loggedUser!: User;

    public initials$: Observable<string> | undefined;
    public avatarUrl$: Observable<string> | undefined;

    public isSmallScreen!: boolean;
    @Input() currentPage!: string;

    constructor(
        private readonly store: Store,
        private readonly sidenavService: SidenavService,
        private router: Router,
        private headerService: HeaderService,
    ) {
        inject(BreakpointObserver)
            .observe(sidenavService.breakPointsThreshold)
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                const matches = result.matches;
                this.isSmallScreen = matches;
            });

        this.headerService.breadcrumbs$
            .pipe(untilDestroyed(this))
            .subscribe((breadcrumbs: BreadcrumbItem[]) => {
                this.breadcrumbs = breadcrumbs;
            });
    }

    ngOnInit() {
        this.loggedUser$ = this.store.select(AuthState.loggedUser);
        this.loggedUser$.pipe(untilDestroyed(this)).subscribe((data: any) => {
            this.loggedUser = data;
        });

        this.avatarUrl$ = this.loggedUser$.pipe(
            filter(Boolean),
            map((user) => {
                if (!user?.avatarPath) {
                    return '';
                }
                return user.avatarPath;
            }),
            untilDestroyed(this),
        );

        this.initials$ = this.loggedUser$.pipe(
            filter(Boolean),
            map((user) => (user.firstname?.charAt(0) || '') + (user.lastname?.charAt(0) || '')),
            untilDestroyed(this),
        );

        this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentPage = this.getPageName(event.urlAfterRedirects);
            }
        });
    }

    public toggleSidenav() {
        this.sidenavService.toggle();
    }

    public openModalUpdateUser(): void {
        this.router.navigate(['/main/account']);
    }

    public logOut(): void {
        this.store.dispatch(new Logout());
    }

    public displayFn(option: { name: string; code: string }): string {
        const display = option && option.name ? option.name : '';
        return display;
    }

    private getPageName(url: string): string {
        if (url.includes('admin')) {
            return 'admin';
        } else {
            return 'other';
        }
    }
}
